import React, { useContext } from "react";
import { DeviceContext, deviceType } from '@providers';

import DesktopWishListPage from "./DesktopWishListPage";
import MobileWishListPage from "./MobileWishListPage";

const WishListPage = () => {
  const { isMobile } = useContext<deviceType>(DeviceContext);

  return (
    isMobile ?
      <MobileWishListPage /> : <DesktopWishListPage />
  )
}
export default WishListPage;
